export let fallbackLng = "th";
export const defaultLng = "th";
export const languages = ["th", "en"];
export const defaultNS = "home";
export const cookieName = "i18next";

export function getOptions(lng: any = fallbackLng, ns: any = defaultNS) {
  const lngFallback = languages.includes(lng) ? lng : defaultLng;

  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng: lngFallback,
    lng: lngFallback,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
